<template>
  <div class="plain-select-field-wrapper my-4">
    <small class="mb-2">{{ label }}</small>
    <v-select
      class="plain-select-field"
      @change="emitValue"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      append-icon="expand_more"
    >
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'PlainSelectField',
  data: () => ({
    textValue: ''
  }),
  props: {
    items: Array,
    label: String,
    itemText: String,
    itemValue: String
  },
  methods: {
    emitValue(value) {
      this.$emit('roundChange', value)
    }
  }
}
</script>

<style lang="scss">
.plain-select-field-wrapper {
  width: 100px;
  margin: auto;
  border-radius: 5px;
  background-color: $primary-background-color;
  text-align: center;
  height: 50px;

  .v-select__selections {
    position: absolute;
    left: 20px;
    top: -7px;
    font-weight: 900;
  }

  .v-input__append-inner {
    margin: 0;
    position: absolute;
    right: -10px;
    top: -3px;
  }

  .v-input__slot {
    width: 50%;
    margin: auto;
    &::before,
    &::after {
      display: none;
    }
  }
  .v-text-field__details {
    display: none;
  }

  .plain-select-field {
    padding: 0;
  }

  .v-icon,
  small {
    opacity: 0.5;
  }
}
</style>
